import React from 'react'
import * as d3 from 'd3';

import { Coords } from '../../types/matrix.types';

interface Props {
    from: [number, number] | Coords
    to: [number, number] | Coords
    strokeColor?: string
    strokeWidth?: number
    strokeOpacity?: number
    fromID?: string
    toID?: string
}



const D3LinkHorizontal: React.FC<Props> = ({
    from, to,
    strokeColor, strokeWidth, strokeOpacity,
    fromID, toID
}) => {


    const lineHorizontal: any = d3.linkHorizontal()
        .x(function (d: any) { return d.x })
        .y(function (d: any) { return d.y });


    const datum = {
        source: {
            x: from[0],
            y: from[1]
        },
        target: {
            x: to[0],
            y: to[1]
        }
    }

    return (
        <path
            data-from-id={fromID || ''}
            data-to-id={toID || ''}
            className={`connecting-line`}

            d={lineHorizontal(datum)}
            fill={'transparent'}
            stroke={strokeColor || `black`}
            strokeWidth={strokeWidth || 5}
            strokeOpacity={strokeOpacity}
        />
    )
}

export default D3LinkHorizontal
